import { FeatureFlagsQuery } from "./graphql";

export enum StorageKey {
  Token = "token",
  User = "user",
  Email = "email",
  Theme = "theme",
  FeatureFlags = "feature_flags",
  AnonymousId = "anonymous_id",
  GoalProps = "goal_props",
  OnboardingFlowState = "onboarding_flow_state",
  PrefillProps = "prefill_props",
  // Holds the user id the final registration conversion was reported for, so a
  // refresh or a back-navigation onto the completion screen cannot fire it twice.
  RegistrationCompleteReportedFor = "registration_complete_reported_for",
  HasSeenGetStarted = "has_seen_get_started",
  // A promo code that arrived on the landing URL. Held for the tab because the entry flow
  // navigates between routes, which drops the query string the code came in on.
  DeeplinkPromoCode = "deeplink_promo_code",
}

export type ApplicationStoreProps = {
  tokenExpired: boolean;
};

export type ApplicationStore = {
  setApplicationProps: (applicationProps: ApplicationStoreProps) => unknown;
  applicationProps: ApplicationStoreProps;
};

export type UseScrollEndEffectProps = {
  fetchMore: () => unknown;
};

export enum Flow {
  Default = "default",
  Onboarding = "onboarding",
  Accounts = "accounts",
  AddGoal = "addGoal",
  EditGoal = "editGoal",
  B2B = "b2b",
  AcceptSharedGoal = "acceptSharedGoal",
  Relinking = "relinking",
}

export enum FeatureFlagValue {
  DisableEmployerAddressOccupation = "DISABLE_EMPLOYER_ADDRESS_OCCUPATION",
  MntEnabled = "MNT_ENABLED",
  FlbEnabled = "FLB_ENABLED",
  ArmstrongEnabled = "ARMSTRONG_ENABLED",
  UmbEnabled = "UMB_ENABLED",
  GreatPlainsEnabled = "GREAT_PLAINS_ENABLED",
  FirstOklahomaEnabled = "FIRST_OKLAHOMA_ENABLED",
  WeokieEnabled = "WEOKIE_ENABLED",
}

export type GetFeatureFlagProps = {
  featureFlags?: FeatureFlagsQuery;
  value: FeatureFlagValue;
};
